import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=75a8256e"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryInformation.vue?vue&type=style&index=0&id=75a8256e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports